
import React from 'react';
// images
import highResDesktopImageWebp from './images/universal-life-insurance-hero.webp';
import highResMobileImageWebp from './images/universal-life-insurance-hero-mobile.webp';
// low res images
import { lowResImageDesktop, lowResImageMobile } from './lowResImages';
// styles
import { HeroSectionStyled } from './styles';

export default () => {
  return (
    <HeroSectionStyled
      sectionId='universal-life-insurance-hero'
      moduleName='hero-module'
      moduleVariation='A'
      productName='Universal Life Insurance'
      headingText='Life insurance that&#39;s flexible to your needs.'
      descriptionText={<>Universal life lets you protect the people you love with great coverage that&#39;s flexible to fit your life.</>}
      ctaPrimary={{
        linkUrl: '/find-a-financial-advisor/',
        buttonText: 'Get insurance',
        ariaLabel: 'Get insurance with a financial professional.',
        children: '',
      }}
      backgroundImageAriaLabel='a father holds his smiling two toddlers in his arms in a grassy field on a sunny day'
      backgroundImageDesktop={highResDesktopImageWebp.toString()}
      backgroundImageMobile={highResMobileImageWebp.toString()}
      backgroundImageDesktopLowRes={lowResImageDesktop}
      backgroundImageMobileLowRes={lowResImageMobile}
      backgroundVariant='lightB'
      themeType='lightTheme'
    />
  );};
